import React from "react";
import { Link } from "react-router-dom";

function WhatNext() {

  return (
    <section style={{ position: "relative" }} className="cta-area cta-bg">
      <div
        style={{
          backgroundColor: "black",
          opacity: 0.5,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      />
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-5 col-lg-6">
            <div
              style={{ zIndex: 1, position: "relative" }}
              className="cta-img">
              <img width={600} src="assets/img/icon/whats-number-mudgames.png" alt="" />
            </div>
          </div>
          <div style={{ zIndex: 2, position: "relative" }} className="col-lg-6">
            <div className="cta-content">
              <div className="cta-icon mb-15">
                <img src="assets/img/icon/cta_icon.png" alt="" />
              </div>
              <div className="section-title title-style-three white-title mb-50">
                <h2>
                  Ready to <span>Monitize?</span>
                </h2>
                <p>
                  Chekout how much you can earn from your existing users. And
                  take a free guide from our experts to know how Mudgame can
                  help you to improve engagment & retention
                </p>
              </div>
              <div className="cta-btn">
                <Link to="/contact" className="btn btn-style-two">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatNext;
